/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BrandMessagePointControllerGetBrandMessagePointResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID: string;
    credit: number;
    createdAt: string;
    updatedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BrandMessagePointControllerGetPointHistoryResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    list?: {
      _id: string;
      writerID?: string;
      type:
        | "ADD_ADMIN"
        | "REMOVE_ADMIN"
        | "ADD_ORDER"
        | "REFUND_ORDER"
        | "USE_ALGORITHM"
        | "USE_ALGORITHM_MODIFY"
        | "REFUND_ALGORITHM"
        | "REFUND_MESSAGE_FAILED"
        | "REFUND_ALGORITHM_MODIFY"
        | "USE_AUTOMATION_BRAND_MESSAGE";
      /** 구분 */
      typeString?: string | null;
      /** 상태 */
      status?:
        | "pending"
        | "paid"
        | "ready"
        | "failed"
        | "cancelled"
        | "partialCancelled"
        | "expired"
        | "revoked"
        | null;
      /** 상태 */
      statusString?: string | null;
      isIncrement: boolean;
      point: number;
      balancedPoint: number;
      credit: number;
      balancedCredit: number;
      baseCredit?: number | null;
      bonusCredit?: number | null;
      amount?: number | null;
      orderID?: string | null;
      /** 결제 완료 시간 */
      paidAt?: string | null;
      /** 결제 실패 시간 */
      failedAt?: string | null;
      /** 취소 시간 */
      cancelledAt?: string | null;
      /** 등록자 */
      writerName?: string | null;
      /** 용도 / 결제수단 */
      reason?: string | null;
      algorithmId?: string | null;
      messageIds?: string[] | null;
      description?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }[];
    countPerPage: number;
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BrandMessagePointControllerGetPriceResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    price: number;
    vat: number;
    chargePerContent: {
      text?: number;
      image?: number;
      wideImage?: number;
      carouselFeeds?: number;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BrandMessagePointControllerRequestSlackNotificationBodyRequest {
  phoneNumber: string;
  userName: string;
}

export interface BrandMessagePointControllerRequestSlackNotificationResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    success: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BrandMessagePaymentControllerChargeCreditsBodyRequest {
  idempotencyKey: string;
  billingCardId: string;
  productID: string;
  /** @default "0" */
  cardQuota?: string;
}

export interface BrandMessagePaymentControllerChargeCreditsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    paymentId: string;
    orderNumber: string;
    credit: number;
    bonusCredit: number;
    paidAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface BrandMessagePaymentControllerGetChargesResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    list: {
      orderId: string;
      orderNumber: string | null;
      total: number;
      tax: number;
      taxedTotal: number;
      credit: number;
      baseCredit: number;
      bonusCredit: number;
      goodsName: string | null;
      status: string;
      method: string;
      writerName: string | null;
      paidAt: string | null;
      cancelledAt: string | null;
      cancelAmount: number | null;
      cardName: string | null;
      maskedCardNumber: string | null;
      receiptUrl: string | null;
    }[];
    countPerPage: number;
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type BrandMessagePointControllerGetBrandMessagePointData =
  BrandMessagePointControllerGetBrandMessagePointResponse;

export interface BrandMessagePointControllerGetPointHistoryParams {
  hospitalID?: string | null;
  type?: "DECREASEMENT" | "INCREASEMENT" | null;
  countPerPage?: number | null;
  currentPage?: number | null;
}

export type BrandMessagePointControllerGetPointHistoryData = BrandMessagePointControllerGetPointHistoryResponse;

export type BrandMessagePointControllerGetPriceData = BrandMessagePointControllerGetPriceResponse;

export type BrandMessagePointControllerRequestSlackNotificationData =
  BrandMessagePointControllerRequestSlackNotificationResponse;

export type BrandMessagePaymentControllerChargeCreditsData = BrandMessagePaymentControllerChargeCreditsResponse;

export interface BrandMessagePaymentControllerGetChargesParams {
  /** @default 20 */
  countPerPage?: number | null;
  /** @default 1 */
  currentPage?: number | null;
}

export type BrandMessagePaymentControllerGetChargesData = BrandMessagePaymentControllerGetChargesResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 브랜드메세지 포인트 조회
     *
     * @tags V3-BrandMessagePoint
     * @name BrandMessagePointControllerGetBrandMessagePoint
     * @summary 브랜드메세지 포인트 조회
     * @request GET:/v3/api/brandmessage-point
     * @secure
     * @response `200` `BrandMessagePointControllerGetBrandMessagePointData` success
     */
    brandMessagePointControllerGetBrandMessagePoint: (params: RequestParams = {}) =>
      this.request<BrandMessagePointControllerGetBrandMessagePointData, any>({
        path: `/v3/api/brandmessage-point`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 포인트 이력 조회
     *
     * @tags V3-BrandMessagePoint
     * @name BrandMessagePointControllerGetPointHistory
     * @summary 브랜드메세지 포인트 이력 조회
     * @request GET:/v3/api/brandmessage-point/history
     * @secure
     * @response `200` `BrandMessagePointControllerGetPointHistoryData` success
     */
    brandMessagePointControllerGetPointHistory: (
      query: BrandMessagePointControllerGetPointHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<BrandMessagePointControllerGetPointHistoryData, any>({
        path: `/v3/api/brandmessage-point/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메세지 단가 조회
     *
     * @tags V3-BrandMessagePoint
     * @name BrandMessagePointControllerGetPrice
     * @summary 브랜드메세지 단가 조회
     * @request GET:/v3/api/brandmessage-point/price
     * @secure
     * @response `200` `BrandMessagePointControllerGetPriceData` success
     */
    brandMessagePointControllerGetPrice: (params: RequestParams = {}) =>
      this.request<BrandMessagePointControllerGetPriceData, any>({
        path: `/v3/api/brandmessage-point/price`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 포인트충전 슬랙 알림 요청
     *
     * @tags V3-BrandMessagePoint-Request-Slack
     * @name BrandMessagePointControllerRequestSlackNotification
     * @summary 포인트충전 슬랙 알림 요청
     * @request POST:/v3/api/brandmessage-point/request-slack
     * @secure
     * @response `200` `BrandMessagePointControllerRequestSlackNotificationData` success
     */
    brandMessagePointControllerRequestSlackNotification: (
      data: BrandMessagePointControllerRequestSlackNotificationBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<BrandMessagePointControllerRequestSlackNotificationData, any>({
        path: `/v3/api/brandmessage-point/request-slack`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 이용권 충전을 위한 결제 API
     *
     * @tags V3-BrandMessagePoint
     * @name BrandMessagePaymentControllerChargeCredits
     * @summary 브랜드메시지 이용권 충전을 위한 결제 API
     * @request POST:/v3/api/brandmessage-point/charges
     * @secure
     * @response `200` `BrandMessagePaymentControllerChargeCreditsData` success
     */
    brandMessagePaymentControllerChargeCredits: (
      data: BrandMessagePaymentControllerChargeCreditsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<BrandMessagePaymentControllerChargeCreditsData, any>({
        path: `/v3/api/brandmessage-point/charges`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 브랜드메시지 이용권 카드 충전 내역 조회
     *
     * @tags V3-BrandMessagePoint
     * @name BrandMessagePaymentControllerGetCharges
     * @summary 브랜드메시지 이용권 카드 충전 내역 조회
     * @request GET:/v3/api/brandmessage-point/charges
     * @secure
     * @response `200` `BrandMessagePaymentControllerGetChargesData` success
     */
    brandMessagePaymentControllerGetCharges: (
      query: BrandMessagePaymentControllerGetChargesParams,
      params: RequestParams = {},
    ) =>
      this.request<BrandMessagePaymentControllerGetChargesData, any>({
        path: `/v3/api/brandmessage-point/charges`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
